<h2>Digital kommunikation</h2>
@if (vm$ | async; as vm) {
    <ng-container [formGroup]="vm.formGroup">
        @if (vm.formGroup.value.telefonnr || vm.formGroup.value.beboeremail) {
            <div>
                <p>Har du ændringer til dit mobilnummer eller din e-mail?</p>
            </div>
        } @else {
            <p>Indtast dit mobilnummer og din e-mail, så vi kan sende dig information digitalt.</p>
        }
        <div class="content">
            <mat-form-field>
                <input matInput type="tel" placeholder="Mobilnummer (sæt komma ved flere mobilnumre)" formControlName="telefonnr" />
            </mat-form-field>
            <mat-form-field>
                <input matInput type="email" placeholder="E-mail (sæt komma ved flere e-mails)" formControlName="beboeremail" />
                @if (vm.formGroup.get("beboeremail").errors) {
                    <mat-error>Indtast en gyldig e-mail</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="button-panel">
            <button mat-button id="kontakt-popup-annuller-knap" tabindex="-1" (click)="onLuk()">Annuller</button>
            <button mat-flat-button id="kontakt-popup-ok-knap" color="primary" (click)="onGem(vm.formGroup)" id="button-ret">Ok</button>
        </div>
    </ng-container>
} @else {
    <spinner></spinner>
}
